"use strict";
import o from "./index.es119.js";
function e(r) {
  return o.isObject(r) && r.isAxiosError === !0;
}
export {
  e as default
};
//# sourceMappingURL=index.es132.js.map
